<template>
  <div class="contentBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="title">นโยบายความเป็นส่วนตัว (Privacy Notice)</p>
        <div class="text"><br>
นโยบายความเป็นส่วนตัวฉบับนี้ (“นโยบาย” หรือ “ประกาศ”) จัดทำขึ้นโดย Max Asset Management Company Limited (“บริษัท” หรือ “ผู้ควบคุมข้อมูล”) เพื่ออธิบายถึงแนวทางในการเก็บรวบรวม ใช้ เปิดเผย และ/หรือประมวลผลข้อมูลส่วนบุคคลของคุณ ซึ่งเป็นผู้ใช้งานแอปพลิเคชัน Maxam สินเชื่อด่วน (“คุณ” หรือ “เจ้าของข้อมูล”) ไม่ว่าจะในนามบุคคลธรรมดาหรือนิติบุคคล<br><br>

การให้ข้อมูลส่วนบุคคลของคุณผ่านแบบฟอร์มลงทะเบียน หรือการใช้งานแพลตฟอร์มในทุกลักษณะ ถือเป็นการยินยอมให้บริษัทประมวลผลข้อมูลของคุณตามวัตถุประสงค์ที่ระบุไว้ในนโยบายฉบับนี้<br><br>
  
การประมวลผลข้อมูลส่วนบุคคลของคุณเป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (“PDPA”) และข้อบังคับที่เกี่ยวข้อง โดยบริษัทจะปฏิบัติตามหลักเกณฑ์ด้าน <br>ความชอบด้วยกฎหมาย ความโปร่งใส ความจำกัดวัตถุประสงค์ ความจำกัดการใช้ ความถูกต้อง ความมั่นคงปลอดภัย และความรับผิดชอบ ทุกประการ<br><br>
  
การเข้าใช้งานแอปพลิเคชันนี้ แสดงว่าคุณได้อ่าน เข้าใจ และตกลงยอมรับข้อกำหนดทั้งหมดที่ระบุในนโยบายความเป็นส่วนตัวฉบับนี้<br><br>
  
รายละเอียดการกู้ยืม<br>
วงเงินกู้ : จำนวนเงินกู้สูงสุด 35,000 บาท.<br>
ระยะเวลา: 93 ถึง 181 วัน.<br>
อัตราดอกเบี้ยสูงสุดต่อปี (APR): 14%/ปี<br>
ไม่มีค่าธรรมเนียมอื่น ๆ<br>
ตัวอย่าง: จำนวนเงินกู้คือ 30,000 บาท และระยะเวลาการกู้คือ 120 วัน คุณเพียงแค่ต้องชำระเงิน<br>
อัตราดอกเบี้ยต่อเดือน : 14%/12=1.16%<br>
ดอกเบี้ยรายเดือน : 30,000 บาท*14%/12=350 บาท<br>
ยอดเงินที่ต้องชำระคืนต่อเดือน : 30,000/4 + 30,000 บาท*15%/12=7,850 บาท<br>
ดอกเบี้ยรวม : 30,000 บาท*14%/12*4=1400 บาท<br>
ค่าธรรมเนียมที่ต้องชำระ: 30,000 บาท + 30,000 บาท*14%/12*4= 3,1400 บาท<br>
        </div>
      </div>
    </div>
    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(1)">
        <div class="left">
          <div class="item-number">01</div>
          <div class="item-title">1. คำนิยาม (Definitions)</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg1 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg1" v-html="text1">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(2)">
        <div class="left">
          <div class="item-number">02</div>
          <div class="item-title">2. ผู้รับผิดชอบข้อมูล</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg2 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg2" v-html="text2">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(3)">
        <div class="left">
          <div class="item-number">03</div>
          <div class="item-title">3. ข้อมูลที่เก็บรวบรวมเมื่อท่านใช้บริการ</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg3 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg3" v-html="text3">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(4)">
        <div class="left">
          <div class="item-number">04</div>
          <div class="item-title">4. วัตถุประสงค์ในการเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคล</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg4 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg4" v-html="text4">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(5)">
        <div class="left">
          <div class="item-number">05</div>
          <div class="item-title">5. ขอบเขตการรักษา</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg5 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg5" v-html="text5">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(6)">
        <div class="left">
          <div class="item-number">06</div>
          <div class="item-title">6. จำกัดการใช้หรือการเปิดเผยข้อมูลส่วนบุคคลของคุณ</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg6 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg6" v-html="text6">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(7)">
        <div class="left">
          <div class="item-number">07</div>
          <div class="item-title">7. การถอนความยินยอม</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg7 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg7" v-html="text7">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(8)">
        <div class="left">
          <div class="item-number">08</div>
          <div class="item-title">8. การใช้สิทธิของเจ้าของข้อมูล</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg8 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg8" v-html="text8">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(9)">
        <div class="left">
          <div class="item-number">09</div>
          <div class="item-title">9. การลบบัญชีผู้ใช้</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg9 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg9" v-html="text9">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(10)">
        <div class="left">
          <div class="item-number">10</div>
          <div class="item-title">10. การแจ้งเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg10 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg10" v-html="text10">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(11)">
        <div class="left">
          <div class="item-number">11</div>
          <div class="item-title">11. การโอนย้ายข้อมูลส่วนบุคคล</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg11 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg11" v-html="text11">
      </div>
    </div>

    <div class="priGroup-Box min-w-1400">
      <div class="priGroup max-w-1400" @click="toggleNewImage(12)">
        <div class="left">
          <div class="item-number">12</div>
          <div class="item-title">12. ติดต่อเรา</div>
        </div>
        <div class="arrow">
          <img class="arrow-img" :src="isActimg12 ? iconUp : iconDown" /></div>
      </div>
      <div class="priText" v-show="isActimg12" v-html="text12">
      </div>
    </div>

    
  </div>
</template>

<script>
import iconUp from "@/page/maxassetcompany/components/img/icon-up.png";
import iconDown from "@/page/maxassetcompany/components/img/icon-down.png";
import y1 from "@/page/maxassetcompany/components/img/y1.png";
import y2 from "@/page/maxassetcompany/components/img/y2.png";
import y3 from "@/page/maxassetcompany/components/img/y3.png";
import y4 from "@/page/maxassetcompany/components/img/y4.png";
import y5 from "@/page/maxassetcompany/components/img/y5.png";
import y6 from "@/page/maxassetcompany/components/img/y6.png";
import y7 from "@/page/maxassetcompany/components/img/y7.png";
import y8 from "@/page/maxassetcompany/components/img/y8.png";
import y9 from "@/page/maxassetcompany/components/img/y9.png";
import y10 from "@/page/maxassetcompany/components/img/y10.png";
import y11 from "@/page/maxassetcompany/components/img/y11.png";
import y12 from "@/page/maxassetcompany/components/img/y12.png";

import yy1 from "@/page/maxassetcompany/components/img/yy1.png";
import yy2 from "@/page/maxassetcompany/components/img/yy2.png";
import yy3 from "@/page/maxassetcompany/components/img/yy3.png";
import yy4 from "@/page/maxassetcompany/components/img/yy4.png";
import yy5 from "@/page/maxassetcompany/components/img/yy5.png";
import yy6 from "@/page/maxassetcompany/components/img/yy6.png";
import yy7 from "@/page/maxassetcompany/components/img/yy7.png";
import yy8 from "@/page/maxassetcompany/components/img/yy8.png";
import yy9 from "@/page/maxassetcompany/components/img/yy9.png";
import yy10 from "@/page/maxassetcompany/components/img/yy10.png";
import yy11 from "@/page/maxassetcompany/components/img/yy11.png";
import yy12 from "@/page/maxassetcompany/components/img/yy12.png";

export default {
  data() {
    return {
      iconDown,
      iconUp,
      yImg1 : y1,
      yImg2 : y2,
      yImg3 : y3,
      yImg4 : y4,
      yImg5 : y5,
      yImg6 : y6,
      yImg7 : y7,
      yImg8 : y8,
      yImg9 : y9,
      yImg10 : y10,
      yImg11 : y11,
      yImg12 : y12,
      yImgAct1 : yy1,
      yImgAct2 : yy2,
      yImgAct3 : yy3,
      yImgAct4 : yy4,
      yImgAct5 : yy5,
      yImgAct6 : yy6,
      yImgAct7 : yy7,
      yImgAct8 : yy8,
      yImgAct9 : yy9,
      yImgAct10 : yy10,
      yImgAct11 : yy11,
      yImgAct12 : yy12,
      isActimg1: false,
      isActimg2: false,
      isActimg3: false,
      isActimg4: false,
      isActimg5: false,
      isActimg6: false,
      isActimg7: false,
      isActimg8: false,
      isActimg9: false,
      isActimg10: false,
      isActimg11: false,
      isActimg12: false,
      altText: "protocolTitle",
      text1:`
ในนโยบายความเป็นส่วนตัวฉบับนี้ คำที่เขียนด้วยตัวอักษรตัวใหญ่จะมีความหมายตามที่กำหนดไว้ดังต่อไปนี้ เว้นแต่จะได้ให้คำนิยามไว้เป็นอย่างอื่นในแต่ละส่วนของนโยบาย:
1.1 “ประกาศ”
หมายถึง เอกสารฉบับนี้ซึ่งจัดทำขึ้นในรูปแบบดิจิทัลหรือเอกสารทางกายภาพ เพื่อชี้แจงแนวทางการประมวลผลข้อมูลส่วนบุคคลโดยผู้ควบคุมข้อมูล ซึ่งเจ้าของข้อมูลสามารถเข้าถึงได้ตลอดระยะเวลาที่มีการประมวลผล
1.2 “การให้บริการแบบคลาวด์”
หมายถึง รูปแบบการให้บริการทางคอมพิวเตอร์ผ่านระบบเครือข่าย ที่ผู้ควบคุมข้อมูลใช้บริการจากผู้ให้บริการภายนอก เพื่อจัดเก็บ ประมวลผล หรือจัดการข้อมูลส่วนบุคคลโดยไม่จำกัดเฉพาะการให้บริการโครงสร้างพื้นฐาน ซอฟต์แวร์ หรือแพลตฟอร์ม
1.3 “บัญชีผู้ใช้งาน”
หมายถึง ช่องทางที่เจ้าของข้อมูลใช้ในการลงทะเบียน เข้าสู่ระบบ และยืนยันตัวตนภายในแอปพลิเคชันของบริษัท
1.4 “ข้อมูลส่วนบุคคล”
หมายถึง ข้อมูลใด ๆ ที่สามารถใช้ระบุตัวตนของบุคคลธรรมดาได้ ไม่ว่าโดยตรงหรือโดยอ้อม ตามที่กฎหมาย PDPA กำหนด
1.5 “ข้อมูลส่วนบุคคลที่มีความอ่อนไหว”
หมายถึง ข้อมูลส่วนบุคคลซึ่งเกี่ยวข้องกับความเชื่อทางศาสนา เชื้อชาติ สุขภาพ ความคิดเห็นทางการเมือง พฤติกรรมทางเพศ หรือข้อมูลอื่นใดที่กฎหมายกำหนดให้เป็นข้อมูลอ่อนไหว ซึ่งอาจก่อให้เกิดความเสี่ยงหรือผลกระทบต่อเจ้าของข้อมูลหากถูกนำไปใช้โดยไม่เหมาะสม
1.6 “สิทธิของเจ้าของข้อมูล (Data Subject Rights)”
หมายถึง สิทธิที่เจ้าของข้อมูลสามารถใช้สิทธิตามที่กฎหมาย PDPA กำหนด ได้แก่:
(i) สิทธิในการเข้าถึงข้อมูลส่วนบุคคลของตน
(ii) สิทธิในการแก้ไขข้อมูลให้ถูกต้อง
(iii) สิทธิในการลบหรือระงับการใช้ข้อมูลบางส่วน
(iv) สิทธิในการคัดค้านการประมวลผลข้อมูล
1.7 “ผู้ประมวลผลข้อมูล”
หมายถึง บุคคลหรือนิติบุคคลที่ดำเนินการประมวลผลข้อมูลส่วนบุคคลแทนผู้ควบคุมข้อมูลตามคำสั่งหรือข้อตกลงที่กำหนดไว้
1.8 “แบบฟอร์มลงทะเบียน”
หมายถึง แบบฟอร์มที่เจ้าของข้อมูลใช้กรอกข้อมูลส่วนบุคคลในการสมัครใช้งานหรือใช้บริการผ่านแอปพลิเคชันของผู้ควบคุมข้อมูล ซึ่งอาจอยู่ในรูปแบบดิจิทัลหรือเอกสาร
1.9 “พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)”
หมายถึง กฎหมายไทยที่ใช้ควบคุมการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของบุคคลธรรมดา
 
ในนโยบายความเป็นส่วนตัวฉบับนี้ คำที่มีการใช้ตัวพิมพ์ใหญ่จะมีความหมายตามที่ระบุไว้ด้านล่างนี้ เพื่อความชัดเจนและสอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562:
เจ้าของข้อมูลส่วนบุคคล (Data Subject) – บุคคลธรรมดาผู้ซึ่งข้อมูลส่วนบุคคลนั้นเกี่ยวข้อง และมีสิทธิตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
ผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller) – นิติบุคคลหรือบุคคลธรรมดาที่มีอำนาจตัดสินใจเกี่ยวกับการเก็บ ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล เช่น บริษัท Max Asset Management Company Limited
ผู้ประมวลผลข้อมูล (Data Processor) – บุคคลหรือนิติบุคคลที่ดำเนินการเกี่ยวกับข้อมูลส่วนบุคุลแทนผู้ควบคุมข้อมูล
แอปพลิเคชัน/แพลตฟอร์ม (Platform) – ช่องทางดิจิทัลของบริษัทที่ให้บริการสินเชื่อผ่านแอปบนมือถือหรือเบราว์เซอร์ เช่น “Maxam สินเชื่อด่วน”
หน่วยงานคุ้มครองข้อมูลส่วนบุคคล (Privacy Office) – หน่วยงานภายในที่ได้รับมอบหมายจากบริษัทให้ดำเนินการเกี่ยวกับสิทธิของเจ้าของข้อมูล
การประมวลผลข้อมูล (Processing) – การดำเนินการใด ๆ เกี่ยวกับข้อมูล เช่น การเก็บรวบรวม ใช้ เข้าถึง เปิดเผย โอน ย้าย หรือลบข้อมูล
การโอนข้อมูล (Transfer) – การส่งต่อข้อมูลส่วนบุคคลไปยังบุคคลหรือนิติบุคคลอื่น ที่อยู่นอกเหนือผู้ควบคุมหรือผู้ประมวลผลข้อมูลเดิม
ผู้ให้บริการคลาวด์ (Cloud Service Provider) – บุคคลหรือนิติบุคคลที่ให้บริการพื้นที่เก็บข้อมูลหรือระบบคำนวณผ่านอินเทอร์เน็ตแก่บริษัท
ข้อกำหนดทางกฎหมาย (Applicable Law) – พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และประกาศหรือแนวปฏิบัติที่เกี่ยวข้อง`,
      text2: `
สำหรับวัตถุประสงค์ของประกาศนี้และตามกฎหมายที่เกี่ยวข้องทั้งหมด บริษัทผู้ควบคุมข้อมูลจะเป็นบริษัท Max Asset Management Company Limited ซึ่งจดทะเบียนอย่างถูกต้องตามกฎหมายของประเทศไทย โดยมีที่อยู่ที่ 36/51 หมู่ที่ 2 ตำบลเกาะแก้ว อำเภอเมืองภูเก็ต จังหวัดภูเก็ต 83000
ผู้ควบคุมข้อมูลดังกล่าวจะรับผิดชอบในการเก็บรวบรวม ใช้งาน เข้าถึง จัดการ ใช้ ส่งต่อ เผยแพร่ และ/หรือจัดเก็บข้อมูลส่วนบุคคลตามวัตถุประสงค์และขอบเขตที่ระบุไว้ในประกาศนี้
ผู้ควบคุมข้อมูลอาจได้รับความช่วยเหลือจากผู้ประมวลผลข้อมูลหลายราย ซึ่งทำหน้าที่แทนผู้ควบคุมข้อมูลเพื่อประมวลผลข้อมูลส่วนบุคคลอย่างมีประสิทธิภาพมากขึ้น โดยผู้ประมวลผลข้อมูลจะต้องปฏิบัติตามหลักเกณฑ์ที่เหมาะสมในการจัดการข้อมูลส่วนบุคคลอย่างเคร่งครัด
นอกจากนี้ ผู้ควบคุมข้อมูลอาจใช้ระบบคลาวด์เพื่อประมวลผลข้อมูลส่วนบุคคล ซึ่งผู้ให้บริการระบบคลาวด์ดังกล่าวต้องปฏิบัติตามกฎหมาย ระเบียบ และมาตรการความปลอดภัยที่เกี่ยวข้อง เพื่อปกป้องข้อมูลส่วนบุคคลที่ได้รับการประมวลผล
ข้อมูลส่วนบุคคลอาจถูกเปิดเผยแก่บุคคลที่สามซึ่งมีความสัมพันธ์ทางธุรกิจหรือมีสัญญาอย่างเป็นทางการกับผู้ควบคุมข้อมูล แต่บุคคลที่สามเหล่านี้ต้องมีมาตรการควบคุมความเป็นส่วนตัวที่เหมาะสม และใช้ข้อมูลส่วนบุคคลดังกล่าวเพื่อวัตถุประสงค์ตามที่ระบุไว้ในประกาศนี้เท่านั้น ทั้งนี้เป็นไปตามข้อกำหนดของมาตรา 36 แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)`,
      text3: `
ผู้ควบคุมข้อมูลจะเก็บรวบรวมข้อมูลส่วนบุคคลของเจ้าของข้อมูลเมื่อใช้บริการผ่านแพลตฟอร์ม ข้อมูลส่วนบุคคลที่เก็บรวบรวมในกรณีนี้ได้แก่:
a) ข้อมูลระบุตัวตนส่วนบุคคล เช่น ชื่อ หมายเลขประจำตัวประชาชน (บัตรประจำตัวประชาชน) วันเกิด เพศ และข้อมูลอื่นๆ ที่จำเป็นต่อการยืนยันตัวตน
b) ข้อมูลส่วนบุคคล เช่น ระดับการศึกษา สถานะการสมรส ที่อยู่ที่ติดต่อได้ อีเมล์ หมายเลขโทรศัพท์ รายได้ต่อเดือน ฯลฯ เพื่อการประเมินเครดิตและกำหนดวงเงินเครดิต
c) ข้อมูลการติดต่อฉุกเฉิน เช่น ชื่อและหมายเลขโทรศัพท์ของผู้ติดต่อรายแรกและรายที่สอง เพื่อให้บริการจัดการเครดิตแก่เจ้าของข้อมูล
d) ข้อมูลบัญชีธนาคาร เช่น ประเภทบัญชี หมายเลขบัญชี ชื่อธนาคาร เพื่อใช้ในการคัดกรองความเสี่ยงต่อการฉ้อโกงและการยืนยันตัวตน รวมถึงการพิจารณาวงเงินกู้ในรูปแบบสินเชื่อ
e) ข้อความ SMS ใช้แจ้งการกู้ยืมเงินสำเร็จ และเตือนให้ชำระคืน เราจะไม่เข้าถึงข้อมูลส่วนตัวใด ๆ ของคุณ
f) การเข้าถึงตำแหน่งอุปกรณ์เพื่อรวบรวมและตรวจยืนยันตำแหน่งในระหว่างกระบวนการสมัครสินเชื่อและลดความเสี่ยงที่เกี่ยวข้อง
g) การอนุญาตเข้าถึงกล้อง: คุณสามารถอนุญาตให้เราเข้าถึงกล้องของคุณ หรือถ่ายรูปหน้าและบัตรประจำตัวของคุณเพื่อช่วยยืนยันตัวตนของคุณ
h) เข้าถึงรายการแอปที่ติดตั้งเพื่อช่วยตรวจจับความเสี่ยงในการฉ้อโกงและยืนยันตัวตนที่แท้จริง
i) สิทธิ์ในการรวบรวมข้อมูลเอกสารแสดงตัวตนและรูปถ่ายใบหน้าของเจ้าของข้อมูล ยืนยันตัวตนตามกฎหมายไทยที่เกี่ยวข้อง
j) สิทธิที่จะรับการแจ้งเตือนสถานะของผลิตภัณฑ์และบริการ รวมทั้งการเตือนวันชำระหนี้ เพื่อป้องกันการผิดนัดชำระ
k) การเข้าถึงปฏิทินเพื่อเตือนคุณเกี่ยวกับวันครบกำหนดชำระเงินและป้องกันผลกระทบต่อเครดิตอันเนื่องมาจากการชำระเงินล่าช้า
l) การเข้าถึง WiFi และสถานะเครือข่าย ระบุการเข้าสู่ระบบระยะไกลระยะสั้นและพฤติกรรมที่ผิดปกติ รักษาความปลอดภัยของบัญชีและป้องกันการฉ้อโกง
m) การเข้าถึงการติดตามโฆษณา (IDFA) ซึ่งใช้เพื่อระบุผู้ใช้เฉพาะสำหรับการโฆษณาแบบกำหนดเป้าหมายและตรวจสอบประสิทธิภาพ รวมถึงความเสี่ยงด้านความปลอดภัยของบัญชีตรวจสอบ
 
เราจะไม่ขอเก็บข้อมูลส่วนบุคคลที่ละเอียดอ่อนโดยตรง เช่น เชื้อชาติ, สายเลือด, สภาพสุขภาพ, ความเชื่อทางปรัชญาหรือศาสนา, มุมมองทางการเมือง, การเป็นสมาชิกสหภาพแรงงาน หรือรสนิยมทางเพศ (เว้นแต่เป็นข้อมูลที่จำเป็นสำหรับการป้องกันการฟอกเงิน)
 
เจ้าของแพลตฟอร์ม (รวมถึงผู้ใช้ทุกคน) ได้รับแจ้งว่า คุกกี้ (Cookies), เว็บบีคอน (Web Beacons) และเทคโนโลยีอื่น ๆ ถูกใช้เพื่อติดตามพฤติกรรมของผู้ใช้อินเทอร์เน็ต เพื่อให้บริการและประสบการณ์การใช้งานบนแพลตฟอร์มที่ดียิ่งขึ้น รวมถึงการนำเสนอผลิตภัณฑ์และบริการใหม่ตามความชอบของท่าน
 
“คุกกี้” คือข้อมูลสั้น ๆ ที่เว็บไซต์ส่งไปยังเบราว์เซอร์ของผู้ใช้และถูกเก็บไว้ในนั้น ซึ่งช่วยให้เว็บไซต์สามารถตรวจสอบกิจกรรมที่ผ่านมาได้ คุกกี้ไม่สามารถอ่านข้อมูลที่อยู่ในฮาร์ดไดรฟ์หรือหน่วยความจำภายในของผู้ใช้ หรืออ่านข้อมูลจากเว็บไซต์อื่น ๆ ได้
 
ข้อมูลส่วนบุคคลที่ได้จากเทคโนโลยีติดตามเหล่านี้ ได้แก่:
(i) เวลาที่ใช้งานในการท่องเว็บไซต์,
(ii) ระยะเวลาที่อยู่บนเว็บไซต์ของผู้ควบคุมข้อมูล,
(iii) ส่วนที่เข้าชม,
(iv) เว็บไซต์ที่เข้าชมก่อนหน้านี้ก่อนเข้ามายังแพลตฟอร์ม
 
หากไม่สามารถเก็บรวบรวมข้อมูลส่วนบุคคลตามที่ระบุในส่วนนี้ได้ ผู้ควบคุมข้อมูลอาจไม่สามารถให้การเข้าถึงแพลตฟอร์มได้`,
      text4: `
ผู้ควบคุมข้อมูลจะเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของเจ้าของข้อมูลเพื่อวัตถุประสงค์ดังต่อไปนี้:
a) เพื่อประเมินคุณสมบัติในการขอสินเชื่อและกำหนดวงเงินสินเชื่อที่เหมาะสมกับเจ้าของข้อมูล
b) เพื่อใช้ในการติดต่อสื่อสารกับผู้ใช้และรับข้อเสนอแนะหรือคำร้องขอบริการที่เกี่ยวข้องกับบริการที่ผู้ควบคุมข้อมูลให้บริการ
c) เพื่อยืนยันตัวตนของผู้ใช้และปฏิบัติตามข้อกำหนดทางกฎหมายที่เกี่ยวข้องกับการป้องกันการฟอกเงินและการสนับสนุนการก่อการร้าย (AML/CFT) ตามกฎหมายที่เกี่ยวข้องของประเทศไทย
d) เพื่อใช้ในการวิเคราะห์ทางสถิติ ปรับปรุงธุรกิจ และบริหารจัดการความเสี่ยงของผู้ควบคุมข้อมูล
e) เพื่อวัตถุประสงค์ด้านการตลาด การโฆษณา และการพัฒนาธุรกิจ โดยได้รับความยินยอมจากเจ้าของข้อมูลอย่างชัดเจน
f) เพื่อให้เจ้าของข้อมูลสามารถใช้ เข้าใช้ และได้รับประโยชน์จากบริการและฟังก์ชันต่าง ๆ ของแพลตฟอร์มได้อย่างถูกต้องตามกฎหมายและปลอดภัย
g) เพื่อวัตถุประสงค์อื่น ๆ ที่เกี่ยวข้องกับความสัมพันธ์ทางกฎหมายที่มีอยู่หรืออาจเกิดขึ้นในอนาคตระหว่างเจ้าของข้อมูลและผู้ควบคุมข้อมูล
ผู้ควบคุมข้อมูลขอรับรองว่าการประมวลผลข้อมูลส่วนบุคคลทั้งหมดจะเป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลของประเทศไทยและกฎหมายที่เกี่ยวข้อง เพื่อปกป้องสิทธิส่วนบุคคลของท่านอย่างเคร่งครัด`,
      text5: `
ผู้ควบคุมสามารถขยายการประมวลผลข้อมูลส่วนบุคคลให้ครอบคลุมจุดประสงค์ใดๆ ที่ระบุไว้ในประกาศนี้ จุดประสงค์ใดๆ ที่เข้ากันได้กับการใช้งานแพลตฟอร์ม และ/หรือจุดประสงค์ขององค์กร จุดประสงค์ที่จำเป็นสำหรับการดำเนินงานภายใต้โครงการคลาวด์คอมพิวติ้ง และการประมวลผลอื่นๆ ที่ได้รับอนุญาตตามกฎหมาย ข้อบังคับ และบทบัญญัติทางกฎหมายอื่นๆ ที่เกี่ยวข้อง
โดยการยอมรับประกาศนี้ เจ้าของข้อมูลรับทราบและอนุญาตให้กรรมการ หุ้นส่วน พนักงาน ทนายความ และบุคลากรอื่น ๆ ของผู้ควบคุมเข้าถึงข้อมูลส่วนบุคคลของตนเพื่อวัตถุประสงค์ในการประมวลผลข้อมูลตามที่ระบุไว้ในประกาศนี้`,
      text6: `
เจ้าของข้อมูลอาจแจ้งต่อผู้ควบคุมว่าเขาหรือเธอต้องการยุติการรับข้อความโฆษณา (ไม่ว่าจะทางโทรศัพท์บ้านหรือโทรศัพท์มือถือ) และอีเมลโฆษณา (ไม่ว่าจะทางไปรษณีย์หรืออีเมล) ในการดำเนินการนี้ เจ้าของจะต้องส่งคำขอเพื่อปิดการใช้งานข้อความโฆษณาและ/หรืออีเมลผ่านแอปพลิเคชัน Maxam สินเชื่อด่วน`,
      text7: `
เจ้าของข้อมูลมีสิทธิ์ถอนความยินยอมในการประมวลผลไม่ว่าความยินยอมนั้นจะเกี่ยวข้องกับข้อมูลส่วนบุคคลของเขาหรือเธอบางส่วนหรือทั้งหมดก็ตาม เพื่อดำเนินการนี้ ผู้ถือจะต้องยื่นใบสมัครที่ตรงตามข้อกำหนดอย่างน้อยดังต่อไปนี้:
ก) ชื่อและที่อยู่ของผู้ถือหรือวิธีการอื่นในการสื่อสารการตอบสนองต่อคำขอของคุณ
ข) เอกสารที่พิสูจน์ตัวตนของเจ้าของ หรือผู้แทนทางกฎหมาย (ถ้ามี)
ค) คำอธิบายที่ชัดเจนและแม่นยำเกี่ยวกับข้อมูลส่วนบุคคลที่คุณต้องการใช้สิทธิ์ใด ๆ ที่ระบุไว้ข้างต้น และ
ง) องค์ประกอบหรือเอกสารอื่นใดที่สามารถช่วยค้นหาข้อมูลส่วนบุคคลได้
การขอเพิกถอนความยินยอมจะต้องส่งผ่านแอปพลิเคชัน Maxam สินเชื่อด่วน เมื่อได้รับคำร้องแล้ว ผู้ควบคุมจะมีเวลา 20 (ยี่สิบ) วันปฏิทินในการตอบกลับเจ้าของข้อมูลส่วนบุคคลโดยส่งคำตอบผ่านที่อยู่อีเมลที่ลงทะเบียนไว้
การถอนความยินยอมเกี่ยวกับข้อมูลส่วนบุคคลซึ่งจำเป็นสำหรับผู้ควบคุมเพื่อส่งมอบผลิตภัณฑ์และ/หรือให้บริการแก่เจ้าของข้อมูล หมายความว่าผู้ควบคุมไม่มีภาระผูกพันที่จะต้องปฏิบัติตามคำขอที่สอดคล้องกัน เนื่องจากไม่สามารถดำเนินการดังกล่าวได้`,
      text8: `
เจ้าของข้อมูลมีสิทธิในการใช้สิทธิพื้นฐานตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA) ดังนี้:
a) สิทธิในการเข้าถึงข้อมูลส่วนบุคคล — เจ้าของข้อมูลสามารถขอเข้าถึงข้อมูลส่วนบุคคลที่ผู้ควบคุมข้อมูลได้เก็บรวบรวมและประมวลผลได้
b) สิทธิในการแก้ไขข้อมูลส่วนบุคคล — เจ้าของข้อมูลสามารถขอแก้ไขข้อมูลส่วนบุคคลที่ไม่ถูกต้อง ไม่ครบถ้วน หรือไม่เป็นปัจจุบันได้
c) สิทธิในการลบข้อมูลส่วนบุคคล — เจ้าของข้อมูลสามารถขอลบข้อมูลส่วนบุคคลของตนได้ หากข้อมูลดังกล่าวไม่จำเป็นสำหรับวัตถุประสงค์ที่ได้แจ้งไว้ หรือการเก็บรักษาข้อมูลนั้นเป็นการฝ่าฝืนกฎหมาย
d) สิทธิในการคัดค้านการประมวลผล — เจ้าของข้อมูลสามารถคัดค้านการประมวลผลข้อมูลส่วนบุคคลของตนได้ หากการประมวลผลนั้นก่อให้เกิดผลเสียหายหรือผิดกฎหมาย
เพื่อใช้สิทธิดังกล่าว เจ้าของข้อมูลสามารถส่งคำร้องผ่านแอป Maxam สินเชื่อด่วน โดยต้องระบุข้อมูลดังต่อไปนี้:
ชื่อ ที่อยู่ และอีเมลของเจ้าของข้อมูล เพื่อใช้ในการติดต่อกลับ
เอกสารแสดงตนของเจ้าของข้อมูล หรือเอกสารแสดงสิทธิ์ตัวแทนตามกฎหมาย (ถ้ามี)
คำอธิบายที่ชัดเจนและแม่นยำเกี่ยวกับข้อมูลส่วนบุคคลที่ต้องการใช้สิทธิ
เอกสารหรือข้อมูลอื่น ๆ ที่ช่วยในการค้นหาข้อมูลส่วนบุคคลนั้น ๆ
ผู้ควบคุมข้อมูลจะดำเนินการตอบกลับคำร้องภายใน 30 วันทำการ นับจากวันที่ได้รับคำร้อง โดยจะส่งผลการดำเนินการไปยังอีเมลที่เจ้าของข้อมูลได้ลงทะเบียนไว้
ทั้งนี้ ในกรณีที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล หรือกฎหมายที่เกี่ยวข้อง อนุญาตให้ผู้ควบคุมข้อมูลปฏิเสธคำร้องขอใช้สิทธิบางประเภท เช่น การปฏิเสธให้เข้าถึงข้อมูล การแก้ไข หรือการลบข้อมูล ผู้ควบคุมข้อมูลจะแจ้งเหตุผลแก่เจ้าของข้อมูลโดยชัดเจน`,
      text9: `
เจ้าของข้อมูลที่ไม่มีภาระผูกพันทางการเงินคงค้างกับผู้ควบคุมข้อมูล สามารถลบบัญชีผู้ใช้และข้อมูลส่วนตัวของตนออกจากแพลตฟอร์มได้โดยการดำเนินการตามขั้นตอนการยกเลิกผ่านแอป Maxam สินเชื่อด่วน
อย่างไรก็ตาม ผู้ควบคุมข้อมูลอาจเก็บรักษาข้อมูลบางส่วนของเจ้าของข้อมูลไว้เพื่อวัตถุประสงค์ทางกฎหมายหรือเพื่อประโยชน์ในการติดต่อแจ้งเตือน เช่น
a) หมายเลขโทรศัพท์มือถือ เพื่อแจ้งยืนยันการลบบัญชี
b) เหตุผลในการลบบัญชีของเจ้าของข้อมูล
การเก็บรักษาข้อมูลดังกล่าวเป็นไปตามข้อกำหนดของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA) และกฎหมายที่เกี่ยวข้อง`,
      text10: `
ผู้ควบคุมข้อมูลขอสงวนสิทธิ์ในการปรับปรุงหรือแก้ไขนโยบายความเป็นส่วนตัวฉบับนี้ตามที่เห็นสมควรและสอดคล้องกับกฎหมายที่เกี่ยวข้อง
เมื่อมีการเปลี่ยนแปลงนโยบายความเป็นส่วนตัว ผู้ควบคุมข้อมูลจะแจ้งให้เจ้าของข้อมูลทราบผ่านการอัปเดตในแอป Maxam สินเชื่อด่วน
เจ้าของข้อมูลมีหน้าที่ตรวจสอบนโยบายความเป็นส่วนตัวฉบับล่าสุดเป็นประจำเพื่อรับทราบข้อมูลและการเปลี่ยนแปลงต่าง ๆ`,
      text11: `
ตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย (PDPA) การโอนย้ายข้อมูลส่วนบุคคลจะดำเนินการโดยคำนึงถึงความเป็นส่วนตัวและสิทธิของเจ้าของข้อมูลเป็นสำคัญ
ผู้ควบคุมข้อมูลสามารถโอนย้ายข้อมูลส่วนบุคคลของเจ้าของข้อมูลไปยังบุคคลภายนอกในกรณีต่าง ๆ ดังนี้ โดยไม่ต้องได้รับความยินยอมล่วงหน้าจากเจ้าของข้อมูล:
a) เมื่อกฎหมายหรือข้อตกลงระหว่างประเทศที่ประเทศไทยเป็นภาคี มีข้อกำหนดให้ต้องมีการโอนย้ายข้อมูล
b) เพื่อป้องกันหรือวินิจฉัยโรค การให้บริการด้านสุขภาพ การรักษาพยาบาล หรือการจัดการบริการด้านสาธารณสุข
c) เมื่อผู้รับโอนข้อมูลเป็นบริษัทในเครือ บริษัทในกลุ่มเดียวกัน หรือบริษัทที่อยู่ภายใต้การควบคุมเดียวกัน และปฏิบัติตามนโยบายและขั้นตอนภายในที่เหมือนกัน
d) เมื่อจำเป็นต้องโอนย้ายข้อมูลตามสัญญาที่ทำขึ้นระหว่างเจ้าของข้อมูล ผู้ควบคุมข้อมูล และบุคคลภายนอก เพื่อประโยชน์ของเจ้าของข้อมูล
e) เพื่อรักษาผลประโยชน์สาธารณะ ดำเนินคดี หรือปฏิบัติงานตามคำสั่งของศาลหรือหน่วยงานที่มีอำนาจ
f) เมื่อการโอนย้ายนั้นจำเป็นต่อการยืนยัน ใช้สิทธิ หรือปกป้องสิทธิของเจ้าของข้อมูลในกระบวนการทางกฎหมาย
g) เมื่อการโอนย้ายนั้นจำเป็นสำหรับการรักษาหรือปฏิบัติตามข้อผูกพันทางกฎหมายระหว่างผู้ควบคุมข้อมูลและเจ้าของข้อมูล
ทั้งนี้ เมื่อผู้ควบคุมข้อมูลมีความประสงค์จะโอนย้ายข้อมูลส่วนบุคคลไปยังบุคคลภายนอกทั้งในและต่างประเทศที่ไม่ใช่ผู้ประมวลผลหรือผู้ให้บริการ ผู้ควบคุมข้อมูลจะต้องแจ้งนโยบายความเป็นส่วนตัวและวัตถุประสงค์การประมวลผลข้อมูลให้แก่เจ้าของข้อมูลทราบล่วงหน้า
กรณีการโอนย้ายข้อมูลที่ไม่อยู่ในข้อกำหนดตามที่กล่าวมา ผู้ควบคุมข้อมูลจะต้องได้รับความยินยอมจากเจ้าของข้อมูลก่อนดำเนินการ`,
      text12: `
หากเจ้าของข้อมูลส่วนบุคคลต้องการสอบถามข้อมูลเพิ่มเติม แก้ไขปัญหา หรือต้องการใช้สิทธิตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล หรือมีข้อสงสัยเกี่ยวกับการใช้สิทธิในข้อมูลส่วนบุคคลของตน สามารถส่งข้อความผ่านแอปพลิเคชัน Maxam สินเชื่อด่วน ได้โดยตรง หากคำขอถูกปฏิเสธ เจ้าของข้อมูลสามารถติดต่อหรือเดินทางมายังที่อยู่ของผู้ควบคุมข้อมูลได้ตามรายละเอียดดังนี้
a) ที่อยู่: 36/51 หมู่ที่ 2 ตำบลเกาะแก้ว อำเภอเมืองภูเก็ต จังหวัดภูเก็ต 83000
b) เบอร์โทรศัพท์: +66 671571219
c) อีเมล: admin@maxassetcompany.com`
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    toggleNewImage(imageIndex) {
      if (imageIndex == 1) {
        this.isActimg1 = !this.isActimg1;
      }
      if (imageIndex == 2) {
        this.isActimg2 = !this.isActimg2;
      }
      if (imageIndex == 3) {
        this.isActimg3 = !this.isActimg3;
      }
      if (imageIndex == 4) {
        this.isActimg4 = !this.isActimg4;
      }
      if (imageIndex == 5) {
        this.isActimg5 = !this.isActimg5;
      }
      if (imageIndex == 6) {
        this.isActimg6 = !this.isActimg6;
      }
      if (imageIndex == 7) {
        this.isActimg7 = !this.isActimg7;
      }
      if (imageIndex == 8) {
        this.isActimg8 = !this.isActimg8;
      }
      if (imageIndex == 9) {
        this.isActimg9 = !this.isActimg9;
      }
      if (imageIndex == 10) {
        this.isActimg10 = !this.isActimg10;
      }
      if (imageIndex == 11) {
        this.isActimg11 = !this.isActimg11;
      }
      if (imageIndex == 12) {
        this.isActimg12 = !this.isActimg12;
      }
    },
  },
};

</script>

<style scoped>
.contentBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  margin-bottom: 50px;
}

.imgBox{
  padding: 0px 200px;
}

.priGroup{
  width: 100%;
  background-color: #F7F4F1;
  padding: 10px;
  border-radius:10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.priGroup-Box{
  padding: 0px 220px;
  margin-bottom: 20px;
}

.left{
  display: flex;
  align-items: center;
}

.item-number{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FB6619;
  height: 50px;
  width: 50px;
  border-radius:10px;
  color: white;
  font-size: 18px;
}

.item-title{
  color: #333;
  font-size: 18px;
  margin-left: 20px;
  font-weight: bold;
}

.arrow{
  height: 100%;
}

.arrow-img{
  height: 50px;
}

.priText{
  padding: 10px;
  font-size: 16px;
  white-space: pre-wrap;
}

.imgBox1,.priBox {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.img1 {
  /* height: 200px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 200px;
}

.title {
  color: #333333;
  font-family: "Thonburi";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}

.text{
  display: block;
  color: #696664;
 font-family: "Thonburi";
 font-size: 20px;
 font-style: normal;
 font-weight: 400;
 line-height: 32px;
 margin-top: 20px;
 white-space: pre-wrap;
}
.imgItem {
  width: 100%;
}

.priBox{
  cursor: pointer;
  margin-bottom: 40px;
}
</style>
